import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Card, Heading, IconSend } from '../../../../../ui';
import { FullProfile } from '../../../model/types';
import useProfileRecordEvent from '../../hooks/useProfileRecordEvent';

export function ReferNowTile({ profile, externalId }: { profile?: FullProfile; externalId?: string }) {
    const history = useHistory();
    const { recordProfileEvent } = useProfileRecordEvent();

    const handleClickRefer = () => {
        recordProfileEvent('Clicked Refer', {
            'Clicked from Location': 'Profile Page',
            'Profile Type': profile?.userType || 'Unknown',
            'External ID': externalId || 'Unknown',
        });

        let link = '/new-referral';
        if (profile) {
            link = '/new-referral?expert=' + encodeURIComponent(`${profile.firstName} ${profile.lastName}`);
        }
        history.push(link);
    };

    return (
        <Card>
            <div className="p-4 py-6 md:p-6 md:py-6 flex flex-col gap-6">
                <Heading level={4}>Make a referral</Heading>
                <div>We'll send your referral to this therapist directly</div>
                <div className="flex justify-end">
                    <Button size="small" onClick={handleClickRefer}>
                        <div className="flex items-center gap-1">
                            <IconSend />
                            Refer
                        </div>
                    </Button>
                </div>
            </div>
        </Card>
    );
}
